import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { PrimecapUtils } from 'src/app/utils/primecap-utils';
import { SetorTag } from '../setor-primecap/model/setor-startup-tag';
import { CardContato, CardRodada, DashboardCard, DetalhesCard } from './model/card-interface';
import { CardClassEnum } from './model/card-class.enum';

@Component({
  selector: 'card-primecap',
  templateUrl: './card-primecap.component.html',
  styleUrls: ['./card-primecap.component.css']
})
export class CardPrimecapComponent implements OnChanges {
  @Input() setorStartupTag!: SetorTag;
  @Input() cardRodada?: CardRodada;
  @Input() detalhesCard?: DetalhesCard;
  @Input() dashboardCard?: DashboardCard;
  @Input() cardContato?: CardContato;
  @Input() cardClass?: string;

  @Output() clickButton = new EventEmitter<MouseEvent>();

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnChanges(): void {
    switch (this.cardClass) {
      case CardClassEnum.DASHBOARD:
        this.setorStartupTag = {
          nome: this.dashboardCard.setorNome,
          corTag: this.dashboardCard.setorCorTag
        };
        break;
      case CardClassEnum.DETALHE:
        this.detalhesCard.empresaInvestida.empresaBanner = this.detalhesCard.empresaInvestida?.empresaBanner ? this.detalhesCard.empresaInvestida?.empresaBanner : '/assets/images/startup-de-sucesso.png';
        this.detalhesCard.empresaInvestida.empresaLogo = this.detalhesCard.empresaInvestida?.empresaLogo ? this.detalhesCard.empresaInvestida?.empresaLogo : '/assets/images/logo.min.svg';
        this.setorStartupTag = this.detalhesCard.setorTag;
        break;
      case CardClassEnum.RODADA:
        if (!this.cardRodada) {
          this.cardRodada = new CardRodada();
          this.cardRodada.textoCard = 'Em breve, novas oportunidades de investimento.'
          this.cardRodada.empresaNome = 'SMUPrime';
          this.cardRodada.banner = '/assets/images/startup-de-sucesso.png';
          this.cardRodada.logo = '/assets/images/logo.min.svg';
          this.cardRodada.valorCaptado = 0;
          this.cardRodada.qtdInvestidores = 0;
          this.setorStartupTag = {
            nome: 'TECNOLOGIA',
            corTag: '#55AEEF'
          };
        } else {
          this.setorStartupTag = {
            nome: this.cardRodada?.setorNome,
            corTag: this.cardRodada?.setorCorTag
          };
        }
        break;
      default:
        this.cardRodada.banner = '/assets/images/startup-de-sucesso.png';
        this.cardRodada.logo = '/assets/images/logo.min.svg';
  		  this.setorStartupTag = {
          nome: 'TECNOLOGIA',
          corTag: '#55AEEF'
        };
        break;
    }
  }

  ngAfterContentChecked(): void {
  	this.cdr.detectChanges();
  }

  primecapButtonClick(): void {
    this.clickButton.emit();
  }

  multiplicarPorCem(valor: number) {
    return PrimecapUtils.multiplicarValorPorCem(valor);
  }
}
